<template>
	<input
		type="text"
		name="counter"
		class="counter__value"
		:value="value"
		@input="onInput"
	/>
</template>

<script setup lang="ts">
import { defineEmits, watch } from 'vue';

interface Props {
	value?: number;
}

const props = defineProps<Props>();
const emit = defineEmits(['input']);

let oldValue: string = String(props.value ?? 0);

watch(
	() => props.value,
	(val) => {
		oldValue = String(val ?? 0);
	}
);

const onInput = (event: Event): void => {
	const target = event.target as HTMLInputElement;
	const newValue = target.value;

	if (!/^-?\d*$/.test(newValue)) {
		target.value = oldValue;
		return;
	}

	oldValue = newValue;
	emit('input', newValue);
};
</script>
